<template>
  <div>
    <menu-pae :inFocus="false">
      <div class="menu">
        <nav class="navbar navbar-expand-lg navbar-bytebank">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <!--
              <div v-if="checkPermissionReservar()" class="like-link" title="Reservar Protocolo" v-on:click="exibirReservarProtocolo()">
                <i class="fa fa-lock fa-3x" style="color: rgb(255, 153, 0);"></i>
              </div> -->
            </li>
          </ul>
        </nav>
      </div>
    </menu-pae>

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item">Reserva</li>
              <li class="breadcrumb-item"> {{ this.booleans.exibirReservarProtocolo ? 'Reservar Protocolos' : 'Consulta' }} </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container-fluid mt-2">
      <filtro-pesquisa-reservados v-show="!this.booleans.exibirReservarProtocolo" class="p-2"
        :rowsNumber="10"
        :eventBusDataName="eventBusDataName"
        :eventBusPaginationName="eventBusPaginationName"/>

      <reservar-protocolo class="p-2" v-show="this.booleans.exibirReservarProtocolo"
        :rowsNumber="10"
        :eventBusDataName="eventBusDataName"
        :eventBusPaginationName="eventBusPaginationName"
        :eventBusShowComponent="eventBusShowComponent"/>
    </div>

    <div class="container-xl">
      <data-table-consulta-comp
        :colNames="colNames"
        :eventBusDataName="eventBusDataName"
        :eventBusDataPaginationName="eventBusPaginationName"
        :dataTableColumn="dataTableColumn"
        :colWidth="colWidth">
        <template v-slot="slotProps">
          <td style="text-align: center; width: 100px !important; white-space: nowrap;">
              <i class="fa fa-search fa-1-5x m-1 link text-info" aria-hidden="true" v-on:click="visualizar($refs, slotProps.itemData.id)"></i>
              <i v-if="checkPermissionExcluir()" class="fa fa-trash-o fa-1-5x m-1 link text-danger" aria-hidden="true" v-on:click="excluir(slotProps.itemData.id)"></i>
          </td>
        </template>
      </data-table-consulta-comp>
    </div>
    <modal ref="modalName"  width="1000px" height="" :eventBusModal="eventBusModal">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Protocolos Reservados</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.modalName.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-footer">
          <reservados-router />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import menuPae from '@/components/Menu'
import filtroPesquisaReservados from '@/components/consulta-processo/FiltroPesquisaReservados'
import reservarProtocolo from '@/components/reservar-protocolo/ReservarProtocolo'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import modal from '@/components/shared/Modal'
import reservadosRouter from '@/components/reservar-protocolo/Reservados'

import eventBus from '@/uteis/eventBus'
import { componentIsVisible, rules } from '@/uteis/action/permissao'

import ReservaProtocoloService from '@/services/ReservaProtocoloService'

export default {
  name: 'reservados',
  components: {
    menuPae,
    filtroPesquisaReservados,
    reservarProtocolo,
    dataTableConsultaComp,
    modal,
    reservadosRouter
  },
  data () {
    return {
      colNames: ['Número Reserva', 'Motivo', 'Data/Hora Reserva', 'Ações'],
      eventBusDataName: 'consultaProcessoReservados',
      eventBusPaginationName: 'consultaProcessoReservadosDataPagination',
      eventBusShowComponent: 'visualizarReservarProtocolo',
      eventBusModal: 'closeModal',
      colWidth: [20, 50, 20, 10],
      booleans: {
        exibirReservarProtocolo: false
      },
      filtro: {
        idReservaProtocolo: '',
        motivoReserva: '',
        tipoProtocolo: '',
        offset: 1,
        range: 10
      },
      dataTableColumn: [
        'id',
        'motivoReserva',
        {
          column: 'dataCriacao',
          converter: 'localDate'
        }
      ]
    }
  },
  created () {
    this.service = new ReservaProtocoloService()
    this.dadosSessao = this.$store.getters.getDadosSessao
    this.filtro.usuario = this.dadosSessao.sessao.login
    this.filtro.idDepartamento = this.dadosSessao.sessao.idDepartamento
    eventBus.$on(this.eventBusShowComponent, (exibirReservarProtocolo) => {
      this.booleans.exibirReservarProtocolo = exibirReservarProtocolo
    })
  },
  methods: {
    visualizar (ref, id) {
      ref.modalName.openModal()
      this.$router.push({ name: 'listaReservados', query: { idReservaProtocolo: id } })
    },
    excluir (id) {
      this.service.excluirReservaProtocolo(id).then((resp) => {
        this.pesquisar()
      })
    },
    exibirReservarProtocolo () {
      this.booleans.exibirReservarProtocolo = true
    },
    checkPermissionReservar () {
      const { COMPONENT_RESERVAR_PROTOCOLO } = rules
      return componentIsVisible(COMPONENT_RESERVAR_PROTOCOLO)
    },
    checkPermissionExcluir () {
      const { COMPONENT_EXCLUIR_RESERVA_PROTOCOLO } = rules
      return componentIsVisible(COMPONENT_EXCLUIR_RESERVA_PROTOCOLO)
    },
    pesquisar () {
      this.service.buscarReservasProtocolo(this.filtro).then((response) => {
        eventBus.$emit(this.eventBusDataName, response)
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.menu {
  position: absolute;
}

.like-link{
    background-color: transparent;
    display: block;
    padding: 0.5rem 1rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    cursor: pointer;
}

.navbar {

  .navbar-bytebank a {
    color: #fff;
  }
  .navbar-bytebank a:hover {
    color: #000;
  }

  .navbar-nav > li {
    margin-right: 15px;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: .75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962BD;
    margin: 10px;
  }

  i {
    color: red;
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;

  div {
    width: 100%;
  }

  .btn {
    margin-left: 5px;
    margin-right: 10px;
  }
}
</style>
